<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 10C6 11.0609 6.42143 12.0783 7.17157 12.8284C7.92172 13.5786 8.93913 14 10 14H16M6 6V32C6 33.0609 6.42143 34.0783 7.17157 34.8284C7.92172 35.5786 8.93913 36 10 36H16M40 20C40.5304 20 41.0391 19.7893 41.4142 19.4142C41.7893 19.0391 42 18.5304 42 18V12C42 11.4696 41.7893 10.9609 41.4142 10.5858C41.0391 10.2107 40.5304 10 40 10H35C34.6895 10 34.3833 9.92771 34.1056 9.78885C33.8279 9.65 33.5863 9.44839 33.4 9.2L31.6 6.8C31.4137 6.55161 31.1721 6.35 30.8944 6.21115C30.6167 6.07229 30.3105 6 30 6H26C25.4696 6 24.9609 6.21071 24.5858 6.58579C24.2107 6.96086 24 7.46957 24 8V18C24 18.5304 24.2107 19.0391 24.5858 19.4142C24.9609 19.7893 25.4696 20 26 20H40ZM40 42C40.5304 42 41.0391 41.7893 41.4142 41.4142C41.7893 41.0391 42 40.5304 42 40V34C42 33.4696 41.7893 32.9609 41.4142 32.5858C41.0391 32.2107 40.5304 32 40 32H34.2C33.8341 31.9952 33.4765 31.8901 33.1661 31.6962C32.8558 31.5022 32.6046 31.2268 32.44 30.9L31.6 29.2C31.4439 28.8422 31.1865 28.538 30.8595 28.3248C30.5325 28.1115 30.1503 27.9986 29.76 28H26C25.4696 28 24.9609 28.2107 24.5858 28.5858C24.2107 28.9609 24 29.4696 24 30V40C24 40.5304 24.2107 41.0391 24.5858 41.4142C24.9609 41.7893 25.4696 42 26 42H40Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'CategoryIcon',
    props: {
        size: { type: [Number, String], default: 24 },
        color: { type: String, default: 'currentColor' },
    },
}
</script>
